import { WeatherStore } from '../schema/WeatherStore';
import { action } from 'satcheljs/lib/legacy';

export let updateCurrentLocationIndex = action('updateCurrentLocationIndex')(
    function updateCurrentLocationIndex(store: WeatherStore, newIndex: number) {
        if (store.currentLocationIndex !== newIndex) {
            store.currentLocationIndex = newIndex;
        }
    }
);
